import { EventData } from "./event-data";

export interface Invitation {
  id: number;
  user_id: number | null;
  user_name: string;
  user_last_name: string;
  user_cpf: string;
  user_phone_number: string;
  user_email: string;
  description: string;
  status: InvitationStatusEnum;
  quantity: number;
  transferable: boolean;
  ticket_id?: number | null;
  ticket?: { title: string; batch_id: number; batch_label: string; type?: string } | null;
  expires_at?: string | null;
  stock_reserved?: boolean;
  created_at: string;
  updated_at: string;
  event: EventData;
}

export interface Meta {
  total_count: number;
  total_pages: number;
  current_page: number;
}

export enum InvitationStatusEnum {
  PENDING = "pending",
  ACCEPTED = "accepted",
  DECLINED = "declined",
  CANCELLED = "cancelled",
  EXPIRED = "expired",
  REVOKED = "revoked",
  CANCELED = "canceled",
}
